// Thư mục: src/services/giayToService.js
import api from "@/api";

/**
 * API service cho Quản lý Giấy tờ
 */
export const GiayToApi = {
  // Lấy danh sách giấy tờ (phân trang)
  list({ page = 0, size = 10, sort = "ngayHetHan,asc" } = {}) {
    // Sắp xếp theo ngày hết hạn gần nhất
    return api
      .get("/api/giay-to", { params: { page, size, sort } })
      .then((res) => res.data);
  },

  // Lấy chi tiết 1 giấy tờ
  get(id) {
    return api.get(`/api/giay-to/${id}`).then((res) => res.data);
  },

  // Tạo giấy tờ mới (nhận GiayToRequestDto)
  create(payload) {
    // Validate payload client-side (optional but recommended)
    if (
      (payload.xeId && payload.nguoiDungId) ||
      (!payload.xeId && !payload.nguoiDungId)
    ) {
      return Promise.reject(
        new Error(
          "Phải chọn Xe hoặc Người dùng (tài xế), không được cả hai hoặc không chọn ai."
        )
      );
    }
    return api.post("/api/giay-to", payload).then((res) => res.data);
  },

  // Cập nhật giấy tờ (nhận GiayToRequestDto)
  update(id, payload) {
    // Validate payload client-side
    if (
      (payload.xeId && payload.nguoiDungId) ||
      (!payload.xeId && !payload.nguoiDungId)
    ) {
      return Promise.reject(
        new Error(
          "Phải chọn Xe hoặc Người dùng (tài xế), không được cả hai hoặc không chọn ai."
        )
      );
    }
    return api.put(`/api/giay-to/${id}`, payload).then((res) => res.data);
  },

  // Xóa giấy tờ
  remove(id) {
    return api.delete(`/api/giay-to/${id}`).then((res) => res.data); // Backend thường trả về 204 No Content
  },

  // Lấy giấy tờ theo Xe ID (nếu cần)
  listByXeId(xeId) {
    return api.get(`/api/giay-to/theo-xe/${xeId}`).then((res) => res.data);
  },

  // Lấy giấy tờ theo Người dùng ID (nếu cần)
  listByNguoiDungId(nguoiDungId) {
    return api
      .get(`/api/giay-to/theo-nguoi-dung/${nguoiDungId}`)
      .then((res) => res.data);
  },
};

// --- API Service phụ trợ ---
// (Em có thể đặt cái này vào xeService.js hoặc nguoiDungService.js)

// Lấy options Xe (ID, bienSo) cho dropdown
export const XeOptionsApi = {
  listForSelect() {
    // Gọi API /options đã có trong XeController
    return api.get("/api/xe/options").then((res) => res.data);
  },
};

// Lấy options Người dùng (Tài xế) cho dropdown
export const TaiXeOptionsApi = {
  listForSelect() {
    // Gọi API lấy người dùng theo chức vụ TAI_XE
    return api
      .get("/api/nguoi-dung/by-chuc-vu-code/TAI_XE")
      .then((res) => res.data);
  },
};
